import instance from "./Instance/index.js";

export const validateAdminPassword = async (password) => {
  try {
    const response = await instance.post(`/admin-password/validate`, { password });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const getAllAdminPasswords = async () => {
  try {
    const response = await instance.get(`/admin-password`);
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const addAdminPassword = async (values) => {
  try {
    const response = await instance.post(`/admin-password`, values);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const updateAdminPassword = async (id, values) => {
  try {
    const response = await instance.put(`/admin-password/${id}`, values);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const deleteAdminPassword = async (id) => {
  try {
    const response = await instance.delete(`/admin-password/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};
